// Inbox 포인터의 kind는 큰 분류, reason은 실제로 일어난 사건이다. reason을 먼저 읽어
// "질문이 열림"과 "질문에 답함"을 같은 문장으로 뭉개지 않는다(E-17).
const REASON_TEXT = Object.freeze({
  'question.opened': '새 질문이 도착했습니다',
  'question.answered': '질문에 답변이 기록되었습니다',
  'question.withdrawn': '질문이 철회되었습니다',
  'handoff.offered': '넘김 제안이 도착했습니다',
  'handoff.accepted': '넘김이 수락되었습니다',
  'handoff.declined': '넘김이 거절되었습니다',
  'handoff.returned': '넘김이 반환되었습니다',
  'proposal.submitted': '새 제안이 올라왔습니다',
  proposal: '제안에 새 소식이 있습니다',
  version: '공동 이해가 새 버전으로 기록되었습니다',
});

const KIND_TEXT = Object.freeze({
  question: '질문에 새 소식이 있습니다',
  handoff: '넘김에 새 소식이 있습니다',
  proposal: '제안에 새 소식이 있습니다',
  version: '공동 이해가 새 버전으로 기록되었습니다',
});

export function inboxPointerText(pointer) {
  return REASON_TEXT[pointer.reason] ?? KIND_TEXT[pointer.kind] ?? pointer.reason ?? pointer.kind;
}
